import { useEffect, useRef, useState } from "react";

export function useVideoAutoplay() {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    let playPromise = null;

    const safePlay = () => {
      playPromise = video.play();
      if (playPromise !== undefined) playPromise.catch(() => {});
    };

    const safePause = () => {
      if (playPromise !== undefined) {
        playPromise.then(() => video.pause()).catch(() => {});
      } else {
        video.pause();
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) safePlay();
        else safePause();
      },
      { threshold: 0.4 }
    );

    observer.observe(video);
    safePlay();

    return () => {
      observer.disconnect();
      safePause();
    };
  }, []);

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    const next = !isMuted;
    video.muted = next;
    setIsMuted(next);
  };

  return { videoRef, isMuted, toggleMute };
}
